import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UrlBuilder } from '../../core/url-builder/url-builder';
import { ActivatedRoute } from '@angular/router';
import { findSelectedStudy, findStudySiteIdentities } from '../../shared/route-helpers';
import { BehaviorSubject } from 'rxjs';

@Component({
    template: require('../redirection.component.html'),
    styles: [require('../redirection.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SponsorTestResultsRedirectionComponent implements OnInit {
    public isActive = new BehaviorSubject(true);

    constructor(
        private readonly route: ActivatedRoute,
        private readonly urlBuilder: UrlBuilder,
    ) { }

    public async ngOnInit(): Promise<void> {
        const selectedStudy = findSelectedStudy(this.route.snapshot);
        const siteIdentities = findStudySiteIdentities(this.route.snapshot);

        if (!selectedStudy || !siteIdentities || siteIdentities.length === 0) {
            this.isActive.next(false);
            return;
        }

        await this.urlBuilder
            .esa()
            .sponsor()
            .study(selectedStudy)
            .testResults(siteIdentities[0].siteId)
            .standardTestResults()
            .navigate({ navigationExtras: { replaceUrl: true } });
    }
}
